import { useTaxonomyContext } from "../contexts/Taxonomy/TaxonomyContext";
import { HgProduct } from "../types/taxonomy";

interface ProductByIds {
  loading: boolean;
  products: HgProduct[];
}

export default function useGetAllProducts(): ProductByIds {
  const context = useTaxonomyContext();

  return {
    loading: context.productsLoading,
    products: context.products,
  };
}
